module.exports = __webpack_public_path__ + "img/gx_icon.3cfa0f3.png";